module.exports = __webpack_public_path__ + "static/semantic-image-spaced-e32ca914784fd962603936cf5e7179a7.png";